
import { useState } from "react"
import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TablePagination, TableBody } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { useSelector } from "react-redux";
import EstatusCuenta from "../../VGrupoDetalle/EstatusCuenta";
import { formatDinero } from "./../../../../utils/formatDinero"
import ButtonDelete from "./ButtonDelete";
import FormularioAItem from "./FomularioAItem";
import ButtonAutorizarCompra from "./ButtonAutorizacion";
import { EstatusCompra } from "./../../../../constant/catEstatusCompra"
const columns = [
    { id: "item", minWidth: 150, align: "center", label: "Item" },
    { id: "montoDivisa", minWidth: 150, align: "center", label: "Monto Divisa" },
    { id: "tC", minWidth: 150, align: "center", label: "T.C." },
    { id: "montoPesos", minWidth: 150, align: "center", label: "Monto MXN" },
    { id: "pagado", minWidth: 150, align: "center", label: "Pagado" },
    { id: "fechaPago", minWidth: 150, align: "center", label: "Fecha Pago" },
    { id: "accion", minWidth: 50, align: "center", label: "" },
]

const useStyles = makeStyles({
    containerRoot: {
        marginTop: "25px",
        marginBottom: "25px"
    },
    containerRootButton: {
        marginTop: "25px",
        marginBottom: "25px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    root: {
        width: '100%',
        padding: '0'
    },
    container: {
        maxHeight: 440,
    },
})

const TablaItems = () => {
    const rows = useSelector(store => store.calendario.compras)
    const { cliente } = useSelector(store => store.calendario)
    const classes = useStyles()
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }
    return (
        <div className={classes.containerRoot}>
            <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.idCompra}>
                                        <TableCell align='center'>
                                            {`${row?.TipoCompra?.Descripcion}`}
                                        </TableCell>
                                        <TableCell align='center'>
                                            {`${formatDinero(row?.MontoProveedor)} ${row?.moneda?.Clave}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${row?.TipoCambio}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${formatDinero(row?.MontoProveedor * row?.TipoCambio)}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {
                                                (row?.estatusCompra?.idEstatusCompra !== EstatusCompra.APROBADO_CLIENTE) &&
                                                <EstatusCuenta estatus={row?.estatusCompra?.idEstatusCompra} />
                                            }
                                            {
                                                (row?.estatusCompra?.idEstatusCompra === EstatusCompra.APROBADO_CLIENTE) &&
                                                <ButtonAutorizarCompra
                                                    Compra={row}
                                                    idPaquete={cliente.paquete?.Id_Paquete}
                                                />
                                            }
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${row?.FechaRegistro.split("T")[0]}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {
                                                (row?.estatusCompra?.idEstatusCompra !== EstatusCompra.PAGADO && row?.estatusCompra?.idEstatusCompra !== EstatusCompra.APROBADO_AGENTE) &&
                                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                                                    <ButtonDelete
                                                        idCompra={row.idCompra}
                                                        Nombre={`${row.TipoCompra?.Descripcion} - ${row.MontoProveedor}`}
                                                        idPaquete={cliente.paquete?.Id_Paquete}
                                                    />
                                                    <FormularioAItem
                                                        idCompra={row.idCompra}
                                                        moneda={row.moneda?.id_moneda}
                                                        monto={row.MontoProveedor}
                                                    />
                                                </div>
                                            }

                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </div>
    )
}
export default TablaItems